<template>
  <AdminFieldWrapper :label="label" @click="isFocused = true">
    <v-btn v-if="focusedAndEmpty" icon small @click.stop="isFocused = false">
      <v-icon
        v-tooltip="getTooltipHtml('You must select a fulfillment type')"
        small
        >mdi-cancel</v-icon
      >
    </v-btn>
    <AdminInputSingleSelect
      v-else
      @keydown.esc="$emit('change', $event)"
      @change="$emit('change', $event)"
      @blur="isFocused = false"
      @focus:change="isFocused = $event"
      :items="fulfillmentSlots"
      v-bind="{ ...$attrs, ...$props }"
    >
      <template #invalid="{ theSelection }">
        <v-btn
          v-tooltip="{
            ...getTooltipHtml(
              'This slot was chosen from another Fulfillment Type'
            ),
          }"
          color="grey grey--text text--darken-3"
          outlined
          small
          class="font-italic caslon--font"
          >{{ theSelection }}</v-btn
        >
      </template>
    </AdminInputSingleSelect>
  </AdminFieldWrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import AvailabilityModel from '@/models/AvailabilityModel'
import _get from 'lodash/get'

import AdminFieldWrapper from '@/components/AdminFieldWrapper'
import AdminInputSingleSelect from '@/components/AdminInputSingleSelect'
export default {
  name: 'AdminFieldFulfillmentSlotPicker',
  components: { AdminFieldWrapper, AdminInputSingleSelect },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    fieldName: {
      type: String,
      require: true,
    },
    label: {
      type: String,
      require: true,
    },
    availability: {
      type: Object,
      default: null,
    },
    fulfillmentType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isFocused: false,
      showTooltip: false,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail', 'getFulfillmentSlotsList']),
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
    fulfillmentSlots() {
      // @TODO ESS: Make this dynamic for multiple fulfillment types
      // Create a constant that reference the API FulfillmentType Enum
      return this.fulfillmentType === 'Pickup'
        ? this.pickupSlots
        : this.deliverySlots
    }, // fulfillmentSlots
    focusedAndEmpty() {
      return (
        this.isFocused &&
        (!this.fulfillmentType || this.fulfillmentType === 'Unknown')
      )
    }, // focusedAndEmpty
    selectedAvailabilityModel() {
      const availabilityId = _get(this.availability, 'id')
      if (!availabilityId) return false
      let selectedAvailability = availabilityId
      if (!selectedAvailability) return false
      return AvailabilityModel.find(selectedAvailability)
    },
    deliverySlots() {
      if (!this.selectedAvailabilityModel) return []
      return this.selectedAvailabilityModel.delivery_slots
    }, // deliverySlots
    pickupSlots() {
      if (!this.selectedAvailabilityModel) return []
      return this.selectedAvailabilityModel.pickup_slots
    }, // pickupSlots
  },
  methods: {
    getTooltipHtml(string) {
      return {
        content: `<div class="proxima--font">${string}</div>`,
        html: true,
      }
    }, // getTooltipHtml
  },
  watch: {
    isFocused(isFocused) {
      if (isFocused) {
        setTimeout(() => (this.isFocused = false), 3000)
      }
    },
  },
}
</script>
